import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CUSTOMER_TYPES } from '../../../services/constant';
import { Router } from '@angular/router';
import { CustomerDetailComponent } from '../customer-detail/customer-detail.component';
import { HttpParams } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../services/authentication.service';
import { AlertService } from '../../../services/alert.service';
var CustomerListComponent = (function () {
    function CustomerListComponent(alertService, apiService, authService, modalService, router) {
        this.alertService = alertService;
        this.apiService = apiService;
        this.authService = authService;
        this.modalService = modalService;
        this.router = router;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.searchingName = false;
        this.searchingTaxID = false;
        this.searchingBranchCode = false;
        this.searchingBranchName = false;
        this.loading = false;
        this.list = [];
        this.customerTypes = CUSTOMER_TYPES;
        this.selectedCustomerType = this.customerTypes[0];
        this.selectedValues = [];
        this.allChecked = false;
        this.modal = null;
        this.modalData = null;
    }
    CustomerListComponent.prototype.ngOnInit = function () {
        this.initData();
        this.search();
    };
    CustomerListComponent.prototype.initData = function () {
        var _this = this;
        this.apiService.getBuyerBranch().subscribe(function (buyerList) {
            _this.buyerNameList = buyerList
                .map(function (obj) { return obj.name; })
                .filter(function (item) { return item; })
                .filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
            _this.buyerBranchCodeList = buyerList
                .map(function (obj) { return obj.branch_code; })
                .filter(function (item) { return item; })
                .filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
            _this.buyerBranchNameList = buyerList
                .map(function (obj) { return obj.branch_name; })
                .filter(function (item) { return item; })
                .filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
            _this.buyerTaxIDList = buyerList
                .map(function (obj) { return obj.tax_id; })
                .filter(function (item) { return item; })
                .filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
        });
    };
    CustomerListComponent.prototype.search = function (resetPage) {
        var _this = this;
        if (resetPage === void 0) { resetPage = true; }
        if (resetPage) {
            this.currentPage = 1;
        }
        var params = new HttpParams()
            .set('page', this.currentPage.toString())
            .set('page_size', this.itemsPerPage.toString())
            .set('required_pagination', 'true');
        if (this.searchName) {
            params = params.append('name', this.searchName);
        }
        if (this.searchTaxID) {
            params = params.append('tax_id', this.searchTaxID);
        }
        if (this.searchBranchCode) {
            params = params.append('branch_code', this.searchBranchCode);
        }
        if (this.searchBranchName) {
            params = params.append('branch_name', this.searchBranchName);
        }
        this.loading = true;
        this.apiService
            .getBuyerBranch(params)
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (response) {
            _this.list = response.results;
            _this.totalItems = response.count;
            _this.selectedValues = Array(_this.totalItems).fill(false);
        }, function (error) {
            console.error(error);
        });
    };
    CustomerListComponent.prototype.clearSearch = function () {
        this.searchName = null;
        this.searchTaxID = null;
        this.searchBranchCode = null;
        this.searchBranchName = null;
        this.search();
    };
    CustomerListComponent.prototype.pageChanged = function () {
        this.search(false);
        this.allChecked = false;
    };
    CustomerListComponent.prototype.optionChanged = function () {
        this.currentPage = 1;
        this.search();
    };
    CustomerListComponent.prototype.openModal = function (index) {
        this.detailModal.open(this, this.selectedCustomerType, this.list[index]);
    };
    CustomerListComponent.prototype.issue = function (index) {
        var id = this.list[index].id;
        this.router.navigate(['document', 'issue', { buyer_branch: id }]);
    };
    CustomerListComponent.prototype.reloadDropdown = function () {
        this.initData();
        this.search();
    };
    CustomerListComponent.prototype.selectDeselectAll = function (checked) {
        this.selectedValues = Array(this.totalItems).fill(checked);
        this.allChecked = checked;
        return;
    };
    CustomerListComponent.prototype.isAllSelect = function () {
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                this.allChecked = false;
            }
        }
        this.allChecked = true;
    };
    CustomerListComponent.prototype.getSelectId = function () {
        var selectedId = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (this.selectedValues[i]) {
                selectedId.push(this.list[i].id);
            }
        }
        return selectedId.join(',');
    };
    CustomerListComponent.prototype.getExportExcel = function () {
        var _this = this;
        var params = {
            search_box: this.getSelectId(),
        };
        this.apiService.getCustomerExcel(params).subscribe(function (obj) {
            var currentDate = moment().format('DD-MM-YYYY');
            var filename = currentDate + "_customer_export.xlsx";
            _this.sniff('DOWNLOAD_XLS', filename);
            _this.apiService.createDownloadFile(obj, filename);
        });
    };
    CustomerListComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'CUS_INFO',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    CustomerListComponent.prototype.confirmDelete = function (index) {
        this.modalData = this.list[index];
        this.modal = this.modalService.open(this.deleteConfirmationModal, {
            backdrop: 'static',
            centered: true
        });
    };
    CustomerListComponent.prototype.confirmedDelete = function (customerId) {
        var _this = this;
        this.apiService.deleteBuyerBranch(customerId).subscribe(function (res) {
            _this.search();
            _this.sniff('DELETE_CUSTOMER', _this.modalData.name);
            _this.closeModal();
        }, function (err) {
            _this.closeModal();
            _this.alertService.toastNotify({
                type: 'error',
                text: err.error.detail,
                timer: 3000,
            });
        });
    };
    CustomerListComponent.prototype.closeModal = function () {
        this.modal.close();
        this.modal = null;
        this.modalData = null;
    };
    Object.defineProperty(CustomerListComponent.prototype, "isAccountantAdmin", {
        get: function () {
            return this.authService.isAccountantAdmin();
        },
        enumerable: true,
        configurable: true
    });
    return CustomerListComponent;
}());
export { CustomerListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-list/customer-list.component.ts.pre-build-optimizer.js